import { Component, OnInit } from '@angular/core';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../shared/formly/ga-formly.service';
import { UntypedFormGroup } from '@angular/forms';
import { FormattingService } from '../../../shared/services/formatting.service';
import { CompanyDataService } from '../../../shared/company/company-data.service';
import { HttpDataService } from '../../../shared/http/http-data.service';

import * as _ from 'underscore';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../../../shared/services/auth/auth.service';

@Component({
  selector: 'ng-select-demo',
  template: `
	  <formly [form]="form" [fields]="fields" [model]="model">
      <button class="btn btn-info" (click)="onButtonClick()">Set new value to select A</button>
		</formly>
    
    <h2>Model</h2>
    <pre>{{model | json}}</pre>
	`,
  providers: [
    CompanyDataService
  ]
})
export class NgSelectDemoComponent implements OnInit {
  private value1 = {id:2228,name:'BARRAU BUSINESS SYSTEMS',companyType:'P',companyGroup:{id:1962,name:'BARRAU BUSINESS SYSTEMS'},gbdm:{id:7417,firstname:'Rodica',lastname:'Grigorescu',email:'rodica_grigorescu@acslworld.com',cellPhone:'32 496 550700',fullName:'Rodica Grigorescu',company:'ACSL',country:'BELGIUM',companyCountryId:1198,companyDepartment:{id:62,description:'VENDOR DESK',company:{id:34,name:'ACSL',companyType:'A',companyGroup:{id:102,name:'ACSL'},gaLayout:{id:'acsl4',description:'ACSL b&w picto in menu'},hasSubCompanies:false,subCompanyMandatory:false,emailSuffix:'@acslworld.com',creationDate:1115663626000,showOnlyCompanyFaqItems:false}},creationDate:1053525042000,active:true,lastLoginDate:1335341158000},hasSubCompanies:false,subCompanyMandatory:false,creationDate:1144792800000,showOnlyCompanyFaqItems:false};
  private value2 = {id:2303,name:'CHECKPOINT',companyType:'C',companyGroup:{id:2015,name:'CHECKPOINT'},gaLayout:{id:'lenovo',description:'Lenovo'},hasSubCompanies:false,subCompanyMandatory:false,creationDate:1161036000000};

  public model:any = {
    testNgSelectA: this.value1,
    testNgSelectC: [{ id: 2228, name: 'BARRAU BUSINESS SYSTEMS' }, { id: 9999, name: 'ABB' }], // ABB should be disabled
    testNgSelectF: ['9', '34']
  };

  public fields:IExtraFieldConfigurationObject[];
  public form:UntypedFormGroup = new UntypedFormGroup({});

  private ngSelectA:IExtraFieldConfigurationObject;
  private ngSelectB:IExtraFieldConfigurationObject;
  private ngSelectC:IExtraFieldConfigurationObject;
  private ngSelectD:IExtraFieldConfigurationObject;
  private ngSelectE:IExtraFieldConfigurationObject;
  private ngSelectF:IExtraFieldConfigurationObject;

  constructor(
    private formlyService:GaFormlyService,
    private formattingService:FormattingService,
    private companyDataService:CompanyDataService,
    private httpDataService: HttpDataService,
    private http: HttpClient,
    private authService: AuthService
  ) {
    /**/
  }

  public ngOnInit():void {
    this.fields = this.createFields();
    // fill fields
    this.fillFields();
  }

  private createFields():IExtraFieldConfigurationObject[] {
    return [
      this.formlyService.aTitle('NG Select')
        .build(),
      this.ngSelectA = this.formlyService.aNgSelect('testNgSelectA', 'Select A (Initial value)')
        .withFormat(this.formattingService.formatCompany)
        .onChange(this.onNGSelectAChange)
        .build(),
      this.ngSelectB = this.formlyService.aNgSelect('testNgSelectB', 'Select B (HTML + Search Term)')
        .withFormat(this.formattingService.formatLocationHtml)
        .onChange(this.onNGSelectBChange)
        .withExtraOptions({
          templateOptions: {
            parseHtml: true
          }
        })
        .build(),
      this.ngSelectC = this.formlyService.aNgSelect('testNgSelectC', 'Select C (Multiple Local Search)')
        .withFormat(this.formattingService.formatCompany)
        .isMultiple()
        .withExtraOptions({
          templateOptions: {
            localSearch: true
          }
        })
        .build(),
      this.ngSelectD = this.formlyService.aNgSelect('testNgSelectD', 'Select D (Multiple Remote Search)')
        .withFormat(this.formattingService.formatContact)
        .isMultiple()
        .withExtraOptions({
          templateOptions: {
            searchFunction: {
              request: (filter:string) => this.companyDataService.getVGAMContacts(filter, 960)
            },
            minSearchLength: 2
          }
        })
        .build(),
      this.ngSelectE = this.formlyService.aNgSelect('testNgSelectE', 'Select E (with Group Options)')
        .withLabelProp('description')
        .withValueProp('value')
        .withGroupProp('group')
        .build(),
      this.ngSelectF = this.formlyService.aNgSelect('testNgSelectF', 'Select F - Large dataset 6k+ (all companies like in report)')
        .withLabelProp('value')
        .withValueProp('id')
        .isMultiple()
        .withOptions([])
        .withExtraOptions({
          templateOptions: {
            localSearch: true,
            addInitialOption: false // this is to prevent value being overwritten by previous value, because options is not finished loading
          }
        })
        .build()
    ];
  }

  private fillFields():void {
    this.formlyService.fillField([this.ngSelectA, this.ngSelectC], this.companyDataService.customerCompanies());
    this.formlyService.fillField(this.ngSelectB, this.getUserLocations(20, 34)); // ACSL Belgium locations
    this.formlyService.fillField(this.ngSelectF, this.getAllCompanies());

    this.formlyService.fillField(this.ngSelectE, this.loadProperties())
      .then(properties => {
        const options:any[] = [];

        _.forEach(properties.data, (propertyList:any) => {
          const propListModel:any = _.findWhere(this.model[ 'testNgSelectE' ], { name: propertyList.name });
          _.forEach(propertyList.values, (property:any) => {
            let propModel:any;
            if (propListModel && propListModel.values) {
              propModel = _.findWhere(propListModel.values, { name: property.name });
            }
            if (!propModel) {
              const option:any = {
                description: property.name,
                value: {
                  list: propertyList.name,
                  field: property.name,
                  control: property.control,
                  definitionId: property.definitionId
                },
                group: propertyList.name
              };
              options.push(option);
            }
          });
        });
        this.ngSelectE.templateOptions.options = options;
        this.ngSelectE.formControl.setValue(options[ 0 ].value);
      });
  }

  private loadProperties():Promise<any> {
    return this.http.get(this.authService.authenticatedUrl('/ga2/rest/globalproduct/properties'))
      .toPromise();
  }

  private onNGSelectAChange = (newValue, oldValue) => {
    console.log('testNgSelectA change', newValue, oldValue, this.model.testNgSelectA);
  };

  private onNGSelectBChange = (newValue, oldValue) => {
    console.log('testNgSelectB change', newValue, oldValue, this.model.testNgSelectB);
  };

  public onButtonClick() {
    // this.model.testNgSelectA = this.value2;
    this.ngSelectA.formControl.setValue(this.value2);
  }

  private getUserLocations(countryId: number, companyId: number, subCompanyId?: number): Promise<any> {
    return this.httpDataService.doGET(
      `rest/userman/userprofile/locations`,
      {
        countryId,
        companyId,
        subCompanyId
      },
      undefined,
      'Error loading locations'
    ).then((x) => {
      x[0].disabled = true;
      return x;
    });
  }

  private getAllCompanies(): Promise<any> {
    return this.httpDataService.doGET(
      `/ga2/rest/reports/8/columns/94/list`,
      undefined,
      undefined,
      'Error fetching all companies'
    );
  }
}